export const Modules = {
    BPN: 'MODULE_BPN',
    SL: 'MODULE_CONCESSIONMANAGER',
    CM: 'MODULE_CONCESSIONMANAGER',
    CU: 'MODULE_CALLUS',
    IC: 'MODULE_INCOMECALCULATOR',
    SG: 'MODULE_SCHEDULEGENIE',
    TU: 'MODULE_TEXTUS',
    IN: 'MODULE_INSITE',
    VA: 'MODULE_CHATBOT',
    CH: 'MODULE_CHAT',
    NB: 'MODULE_NOTIFICATIONBANNER'
};

export const ModuleShortCodes = {
    MODULE_CONCESSIONMANAGER: 'SL',
    MODULE_INSITE: 'IN',
    MODULE_BPN: 'BPN',
    MODULE_CALLUS: 'CU',
    MODULE_INCOMECALCULATOR: 'IC',
    MODULE_SCHEDULEGENIE: 'SG',
    MODULE_TEXTUS: 'TU',
    MODULE_CHATBOT: 'VA',
    MODULE_CHAT: 'CH',
    MODULE_NOTIFICATIONBANNER: 'NB'
};

export const ModuleBarSkins = {
    DEFAULT: 'default',
    WALLET: 'skin1'
};

export const PREVIEW = 'TCC_PREVIEW';

const bounce = `@-webkit-keyframes bounce {
    0%, 3.34%, 8.85%, 13.36%, to {
        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
        -webkit-transform: translateZ(0);
        animation-timing-function: cubic-bezier(.215, .61, .355, 1);
        transform: translateZ(0);
    }

    6.68%, 7.18% {
        -webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
        -webkit-transform: translate3d(0, -30px, 0);
        animation-timing-function: cubic-bezier(.755, .05, .855, .06);
        transform: translate3d(0, -30px, 0);
    }

    11.69% {
        -webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
        -webkit-transform: translate3d(0, -15px, 0);
        animation-timing-function: cubic-bezier(.755, .05, .855, .06);
        transform: translate3d(0, -15px, 0);
    }

    15.03%, 100% {
        -webkit-transform: translate3d(0, -4px, 0);
        transform: translate3d(0, -4px, 0);
    }
}

@keyframes bounce {
    0%, 3.34%, 8.85%, 13.36%, to {
        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
        -webkit-transform: translateZ(0);
        animation-timing-function: cubic-bezier(.215, .61, .355, 1);
        transform: translateZ(0);
    }

    6.68%, 7.18% {
        -webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
        -webkit-transform: translate3d(0, -30px, 0);
        animation-timing-function: cubic-bezier(.755, .05, .855, .06);
        transform: translate3d(0, -30px, 0);
    }

    11.69% {
        -webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
        -webkit-transform: translate3d(0, -15px, 0);
        animation-timing-function: cubic-bezier(.755, .05, .855, .06);
        transform: translate3d(0, -15px, 0);
    }

    15.03% {
        -webkit-transform: translate3d(0, -4px, 0);
        transform: translate3d(0, -4px, 0);
    }

    16.7%, 100% {
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
    }
}`;

const bounceStyle = `.bounce {
    -webkit-animation-name: bounce;
    -webkit-transform-origin: center bottom;
    animation-name: bounce;
    transform-origin: center bottom;
    -webkit-animation-duration: 12s;
    animation-duration: 12s;
    animation-iteration-count: infinite;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;  
    -o-animation-iteration-count: infinite;
}`;

const heartBeat = `@-webkit-keyframes heartBeat {
    0% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }

    1.61% {
        -webkit-transform: scale(1.3);
        transform: scale(1.3);
    }

    3.22% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }

    4.83% {
        -webkit-transform: scale(1.3);
        transform: scale(1.3);
    }

    8.05%, 100% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}

@keyframes heartBeat {
    0% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }

    1.61% {
        -webkit-transform: scale(1.3);
        transform: scale(1.3);
    }

    3.22% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }

    4.83% {
        -webkit-transform: scale(1.3);
        transform: scale(1.3);
    }

    8.05%, 100% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}`;

const heartBeatStyle = `.heartBeat {
    -webkit-animation-duration: 1.3s;
    -webkit-animation-name: heartBeat;
    -webkit-animation-timing-function: ease-in-out;
    -webkit-animation-duration: 11.3s;
    animation-duration: 11.3s;
    animation-name: heartBeat;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;  
    -o-animation-iteration-count: infinite;
}`;

const jello = `@-webkit-keyframes jello {
    0%, 1.85%, to {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }

    3.71% {
        -webkit-transform: skewX(-12.5deg) skewY(-12.5deg);
        transform: skewX(-12.5deg) skewY(-12.5deg);
    }

    5.56% {
        -webkit-transform: skewX(6.25deg) skewY(6.25deg);
        transform: skewX(6.25deg) skewY(6.25deg);
    }

    7.41% {
        -webkit-transform: skewX(-3.125deg) skewY(-3.125deg);
        transform: skewX(-3.125deg) skewY(-3.125deg);
    }

    9.27% {
        -webkit-transform: skewX(1.5625deg) skewY(1.5625deg);
        transform: skewX(1.5625deg) skewY(1.5625deg);
    }

    11.12% {
        -webkit-transform: skewX(-.78125deg) skewY(-.78125deg);
        transform: skewX(-.78125deg) skewY(-.78125deg);
    }

    12.98% {
        -webkit-transform: skewX(.390625deg) skewY(.390625deg);
        transform: skewX(.390625deg) skewY(.390625deg);
    }

    14.83% {
        -webkit-transform: skewX(-.1953125deg) skewY(-.1953125deg);
        transform: skewX(-.1953125deg) skewY(-.1953125deg);
    }

    16.7%, 100% {
        -webkit-transform: skewX(0deg) skewY(0deg);
        transform: skewX(0deg) skewY(0deg);
    }
}

@keyframes jello {
    0%, 1.85%, to {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }

    3.71% {
        -webkit-transform: skewX(-12.5deg) skewY(-12.5deg);
        transform: skewX(-12.5deg) skewY(-12.5deg);
    }

    5.56% {
        -webkit-transform: skewX(6.25deg) skewY(6.25deg);
        transform: skewX(6.25deg) skewY(6.25deg);
    }

    7.41% {
        -webkit-transform: skewX(-3.125deg) skewY(-3.125deg);
        transform: skewX(-3.125deg) skewY(-3.125deg);
    }

    9.27% {
        -webkit-transform: skewX(1.5625deg) skewY(1.5625deg);
        transform: skewX(1.5625deg) skewY(1.5625deg);
    }

    11.12% {
        -webkit-transform: skewX(-.78125deg) skewY(-.78125deg);
        transform: skewX(-.78125deg) skewY(-.78125deg);
    }

    12.98% {
        -webkit-transform: skewX(.390625deg) skewY(.390625deg);
        transform: skewX(.390625deg) skewY(.390625deg);
    }

    14.83% {
        -webkit-transform: skewX(-.1953125deg) skewY(-.1953125deg);
        transform: skewX(-.1953125deg) skewY(-.1953125deg);
    }

    16.7%, 100% {
        -webkit-transform: skewX(0deg) skewY(0deg);
        transform: skewX(0deg) skewY(0deg);
    }
}`;

const jelloStyle = `.jello {
    -webkit-animation-name: jello;
    -webkit-transform-origin: center;
    animation-name: jello;
    transform-origin: center;
    -webkit-animation-duration: 12s;
    animation-duration: 12s;
    animation-iteration-count: infinite;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;  
    -o-animation-iteration-count: infinite;
}`;

const pulse = `@-webkit-keyframes pulse {
    0% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
    }

    8.35% {
        -webkit-transform: scale3d(1.05, 1.05, 1.05);
        transform: scale3d(1.05, 1.05, 1.05);
    }

    16.7%, 100% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
    }
}

@keyframes pulse {
    0% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
    }

    8.35% {
        -webkit-transform: scale3d(1.05, 1.05, 1.05);
        transform: scale3d(1.05, 1.05, 1.05);
    }

    16.7%, 100% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
    }
}`;

const pulseStyle = `.pulse {
    -webkit-animation-name: pulse;
    animation-name: pulse;
    -webkit-animation-duration: 12s;
    animation-duration: 12s;
    animation-iteration-count: infinite;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;  
    -o-animation-iteration-count: infinite;
}`;

const rubberBand = `@-webkit-keyframes rubberBand {
    0% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
    }

    5.01% {
        -webkit-transform: scale3d(1.25, .75, 1);
        transform: scale3d(1.25, .75, 1);
    }

    6.68% {
        -webkit-transform: scale3d(.75, 1.25, 1);
        transform: scale3d(.75, 1.25, 1);
    }

    8.35% {
        -webkit-transform: scale3d(1.15, .85, 1);
        transform: scale3d(1.15, .85, 1);
    }

    10.86% {
        -webkit-transform: scale3d(.95, 1.05, 1);
        transform: scale3d(.95, 1.05, 1);
    }

    12.52% {
        -webkit-transform: scale3d(1.05, .95, 1);
        transform: scale3d(1.05, .95, 1);
    }

    16.7%, 100% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
    }
}

@keyframes rubberBand {
    0% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
    }

    5.01% {
        -webkit-transform: scale3d(1.25, .75, 1);
        transform: scale3d(1.25, .75, 1);
    }

    6.68% {
        -webkit-transform: scale3d(.75, 1.25, 1);
        transform: scale3d(.75, 1.25, 1);
    }

    8.35% {
        -webkit-transform: scale3d(1.15, .85, 1);
        transform: scale3d(1.15, .85, 1);
    }

    10.86% {
        -webkit-transform: scale3d(.95, 1.05, 1);
        transform: scale3d(.95, 1.05, 1);
    }

    12.52% {
        -webkit-transform: scale3d(1.05, .95, 1);
        transform: scale3d(1.05, .95, 1);
    }

    16.7%, 100% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
    }
}`;

const rubberBandStyle = `.rubberBand {
    -webkit-animation-name: rubberBand;
    animation-name: rubberBand;
    -webkit-animation-duration: 12s;
    animation-duration: 12s;
    animation-iteration-count: infinite;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;  
    -o-animation-iteration-count: infinite;
}`;

const shake = `@-webkit-keyframes shake {
    0% {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }

    1.67%, 5.01%, 8.35%, 11.69.%, 15.03% {
        -webkit-transform: translate3d(-10px, 0, 0);
        transform: translate3d(-10px, 0, 0);
    }

    3.34%, 6.68%, 10.02%, 13.36% {
        -webkit-transform: translate3d(10px, 0, 0);
        transform: translate3d(10px, 0, 0);
    }

    16.7%, 100% {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }
}

@keyframes shake {
    0% {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }

    1.67%, 5.01%, 8.35%, 11.69%, 15.03% {
        -webkit-transform: translate3d(-10px, 0, 0);
        transform: translate3d(-10px, 0, 0);
    }

    3.34%, 6.68%, 10.02%, 13.36% {
        -webkit-transform: translate3d(10px, 0, 0);
        transform: translate3d(10px, 0, 0);
    }

    16.7%, 100% {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }
}`;

const shakeStyle = `.shake {
    -webkit-animation-name: shake;
    animation-name: shake;
    -webkit-animation-duration: 12s;
    animation-duration: 12s;
    animation-iteration-count: infinite;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;  
    -o-animation-iteration-count: infinite;
}`;

const swing = `@-webkit-keyframes swing {
    3.34% {
        -webkit-transform: rotate(15deg);
        transform: rotate(15deg);
    }

    6.68% {
        -webkit-transform: rotate(-10deg);
        transform: rotate(-10deg);
    }

    10.02% {
        -webkit-transform: rotate(5deg);
        transform: rotate(5deg);
    }

    13.36% {
        -webkit-transform: rotate(-5deg);
        transform: rotate(-5deg);
    }

    16.7%, 100% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
}

@keyframes swing {
    3.34% {
        -webkit-transform: rotate(15deg);
        transform: rotate(15deg);
    }

    6.68% {
        -webkit-transform: rotate(-10deg);
        transform: rotate(-10deg);
    }

    10.02% {
        -webkit-transform: rotate(5deg);
        transform: rotate(5deg);
    }

    13.36% {
        -webkit-transform: rotate(-5deg);
        transform: rotate(-5deg);
    }

    16.7%, 100% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
}`;

const swingStyle = `.swing {
    -webkit-animation-name: swing;
    -webkit-transform-origin: top center;
    animation-name: swing;
    transform-origin: top center;
    -webkit-animation-duration: 12s;
    animation-duration: 12s;
    animation-iteration-count: infinite;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;  
    -o-animation-iteration-count: infinite;
}`;

const tada = `@-webkit-keyframes tada {
    0% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
    }

    1.67%, 3.34% {
        -webkit-transform: scale3d(.9, .9, .9) rotate(-3deg);
        transform: scale3d(.9, .9, .9) rotate(-3deg);
    }

    5.01%, 8.35%, 11.69%, 15.03% {
        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
        transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
    }

    6.68%, 10.02%, 13.36% {
        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
        transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
    }

    16.7%, 100% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
    }
}

@keyframes tada {
    0% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
    }

    1.67%, 3.34% {
        -webkit-transform: scale3d(.9, .9, .9) rotate(-3deg);
        transform: scale3d(.9, .9, .9) rotate(-3deg);
    }

    5.01%, 8.35%, 11.69%, 15.03% {
        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
        transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
    }

    6.68%, 10.02%, 13.36% {
        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
        transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
    }

    16.7%, 100% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
    }
}`;

const tadaStyle = `.tada {
    -webkit-animation-name: tada;
    animation-name: tada;
    -webkit-animation-duration: 12s;
    animation-duration: 12s;
    animation-iteration-count: infinite;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;  
    -o-animation-iteration-count: infinite;
}`;

const wobble = `@-webkit-keyframes wobble {
    0% {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }

    1.37% {
        -webkit-transform: translate3d(-25%, 0, 0) rotate(-5deg);
        transform: translate3d(-25%, 0, 0) rotate(-5deg);
    }

    2.73% {
        -webkit-transform: translate3d(20%, 0, 0) rotate(3deg);
        transform: translate3d(20%, 0, 0) rotate(3deg);
    }

    4.1% {
        -webkit-transform: translate3d(-15%, 0, 0) rotate(-3deg);
        transform: translate3d(-15%, 0, 0) rotate(-3deg);
    }

    5.46% {
        -webkit-transform: translate3d(10%, 0, 0) rotate(2deg);
        transform: translate3d(10%, 0, 0) rotate(2deg);
    }

    6.82% {
        -webkit-transform: translate3d(-5%, 0, 0) rotate(-1deg);
        transform: translate3d(-5%, 0, 0) rotate(-1deg);
    }

    9.1%, 100% {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }
}

@keyframes wobble {
    0% {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }

    1.37% {
        -webkit-transform: translate3d(-25%, 0, 0) rotate(-5deg);
        transform: translate3d(-25%, 0, 0) rotate(-5deg);
    }

    2.73% {
        -webkit-transform: translate3d(20%, 0, 0) rotate(3deg);
        transform: translate3d(20%, 0, 0) rotate(3deg);
    }

    4.1% {
        -webkit-transform: translate3d(-15%, 0, 0) rotate(-3deg);
        transform: translate3d(-15%, 0, 0) rotate(-3deg);
    }

    5.46% {
        -webkit-transform: translate3d(10%, 0, 0) rotate(2deg);
        transform: translate3d(10%, 0, 0) rotate(2deg);
    }

    6.82% {
        -webkit-transform: translate3d(-5%, 0, 0) rotate(-1deg);
        transform: translate3d(-5%, 0, 0) rotate(-1deg);
    }

    9.1%, 100% {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }
}`;

const wobbleStyle = `.wobble {
    -webkit-animation-name: wobble;
    animation-name: wobble;
    -webkit-animation-duration: 11s;
    animation-duration: 11s;
    animation-iteration-count: infinite;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;  
    -o-animation-iteration-count: infinite;
}`;

const bounceKeyFrame = `
    0%, 3.34%, 8.85%, 13.36%, to {
        -webkit-animation-timing-function: cubic-bezier(.215, .61, .355, 1);
        -webkit-transform: translateZ(0);
        animation-timing-function: cubic-bezier(.215, .61, .355, 1);
        transform: translateZ(0);
    }

    6.68%, 7.18% {
        -webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
        -webkit-transform: translate3d(0, -30px, 0);
        animation-timing-function: cubic-bezier(.755, .05, .855, .06);
        transform: translate3d(0, -30px, 0);
    }

    11.69% {
        -webkit-animation-timing-function: cubic-bezier(.755, .05, .855, .06);
        -webkit-transform: translate3d(0, -15px, 0);
        animation-timing-function: cubic-bezier(.755, .05, .855, .06);
        transform: translate3d(0, -15px, 0);
    }

    15.03%, 100% {
        -webkit-transform: translate3d(0, -4px, 0);
        transform: translate3d(0, -4px, 0);
    }`;

const heartBeatKeyFrame = `
    0% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }

    1.61% {
        -webkit-transform: scale(1.3);
        transform: scale(1.3);
    }

    3.22% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }

    4.83% {
        -webkit-transform: scale(1.3);
        transform: scale(1.3);
    }

    8.05%, 100% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
`;

const jelloKeyFrame = `
    0%, 1.85%, to {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }

    3.71% {
        -webkit-transform: skewX(-12.5deg) skewY(-12.5deg);
        transform: skewX(-12.5deg) skewY(-12.5deg);
    }

    5.56% {
        -webkit-transform: skewX(6.25deg) skewY(6.25deg);
        transform: skewX(6.25deg) skewY(6.25deg);
    }

    7.41% {
        -webkit-transform: skewX(-3.125deg) skewY(-3.125deg);
        transform: skewX(-3.125deg) skewY(-3.125deg);
    }

    9.27% {
        -webkit-transform: skewX(1.5625deg) skewY(1.5625deg);
        transform: skewX(1.5625deg) skewY(1.5625deg);
    }

    11.12% {
        -webkit-transform: skewX(-.78125deg) skewY(-.78125deg);
        transform: skewX(-.78125deg) skewY(-.78125deg);
    }

    12.98% {
        -webkit-transform: skewX(.390625deg) skewY(.390625deg);
        transform: skewX(.390625deg) skewY(.390625deg);
    }

    14.83% {
        -webkit-transform: skewX(-.1953125deg) skewY(-.1953125deg);
        transform: skewX(-.1953125deg) skewY(-.1953125deg);
    }

    16.7%, 100% {
        -webkit-transform: skewX(0deg) skewY(0deg);
        transform: skewX(0deg) skewY(0deg);
    }
`;
const pulseKeyFrame = `
    0% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
    }

    8.35% {
        -webkit-transform: scale3d(1.05, 1.05, 1.05);
        transform: scale3d(1.05, 1.05, 1.05);
    }

    16.7%, 100% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
    }
`;
const rubberBandKeyFrame = `
    0% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
    }

    5.01% {
        -webkit-transform: scale3d(1.25, .75, 1);
        transform: scale3d(1.25, .75, 1);
    }

    6.68% {
        -webkit-transform: scale3d(.75, 1.25, 1);
        transform: scale3d(.75, 1.25, 1);
    }

    8.35% {
        -webkit-transform: scale3d(1.15, .85, 1);
        transform: scale3d(1.15, .85, 1);
    }

    10.86% {
        -webkit-transform: scale3d(.95, 1.05, 1);
        transform: scale3d(.95, 1.05, 1);
    }

    12.52% {
        -webkit-transform: scale3d(1.05, .95, 1);
        transform: scale3d(1.05, .95, 1);
    }

    16.7%, 100% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
    }
`;
const shakeKeyFrame = `
    0% {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }

    1.67%, 5.01%, 8.35%, 11.69.%, 15.03% {
        -webkit-transform: translate3d(-10px, 0, 0);
        transform: translate3d(-10px, 0, 0);
    }

    3.34%, 6.68%, 10.02%, 13.36% {
        -webkit-transform: translate3d(10px, 0, 0);
        transform: translate3d(10px, 0, 0);
    }

    16.7%, 100% {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }
`;
const swingKeyFrame = `
    3.34% {
        -webkit-transform: rotate(15deg);
        transform: rotate(15deg);
    }

    6.68% {
        -webkit-transform: rotate(-10deg);
        transform: rotate(-10deg);
    }

    10.02% {
        -webkit-transform: rotate(5deg);
        transform: rotate(5deg);
    }

    13.36% {
        -webkit-transform: rotate(-5deg);
        transform: rotate(-5deg);
    }

    16.7%, 100% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
`;
const tadaKeyFrame = `
    0% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
    }

    1.67%, 3.34% {
        -webkit-transform: scale3d(.9, .9, .9) rotate(-3deg);
        transform: scale3d(.9, .9, .9) rotate(-3deg);
    }

    5.01%, 8.35%, 11.69%, 15.03% {
        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
        transform: scale3d(1.1, 1.1, 1.1) rotate(3deg);
    }

    6.68%, 10.02%, 13.36% {
        -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
        transform: scale3d(1.1, 1.1, 1.1) rotate(-3deg);
    }

    16.7%, 100% {
        -webkit-transform: scaleX(1);
        transform: scaleX(1);
    }
`;
const wobbleKeyFrame = `
    0% {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }

    1.37% {
        -webkit-transform: translate3d(-25%, 0, 0) rotate(-5deg);
        transform: translate3d(-25%, 0, 0) rotate(-5deg);
    }

    2.73% {
        -webkit-transform: translate3d(20%, 0, 0) rotate(3deg);
        transform: translate3d(20%, 0, 0) rotate(3deg);
    }

    4.1% {
        -webkit-transform: translate3d(-15%, 0, 0) rotate(-3deg);
        transform: translate3d(-15%, 0, 0) rotate(-3deg);
    }

    5.46% {
        -webkit-transform: translate3d(10%, 0, 0) rotate(2deg);
        transform: translate3d(10%, 0, 0) rotate(2deg);
    }

    6.82% {
        -webkit-transform: translate3d(-5%, 0, 0) rotate(-1deg);
        transform: translate3d(-5%, 0, 0) rotate(-1deg);
    }

    9.1%, 100% {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }
`;

export const animations = {
    bounce,
    heartBeat,
    jello,
    pulse,
    rubberBand,
    shake,
    swing,
    tada,
    wobble
};

export const animationStyles = {
    bounceStyle,
    heartBeatStyle,
    jelloStyle,
    pulseStyle,
    rubberBandStyle,
    shakeStyle,
    swingStyle,
    tadaStyle,
    wobbleStyle
};

export const animationKeyFrames = {
    bounceKeyFrame,
    heartBeatKeyFrame,
    jelloKeyFrame,
    pulseKeyFrame,
    rubberBandKeyFrame,
    shakeKeyFrame,
    swingKeyFrame,
    tadaKeyFrame,
    wobbleKeyFrame
};
